export default __webpack_public_path__ + "static/media/02.b564a727.png";